import { render, staticRenderFns } from "./FitGapForm.vue?vue&type=template&id=4d39e7f6&scoped=true"
import script from "./FitGapForm.vue?vue&type=script&lang=js"
export * from "./FitGapForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d39e7f6",
  null
  
)

export default component.exports